import { Roles } from "projects/shared/models/enums/roles.enum"
import { BanStatus, IUser } from "projects/shared/models/interfaces/user.model"

export interface UserState {
  data: IUser;
  login?: boolean
}

export const InitialUserState: UserState = {
  data: {
    _id: "",
    name: "",
    password: "",
    email: "",
    phone: "",
    token: "",
    is2FAEnabled: "",
    verificationData: { images: [], idType: "" },
    isAdmin: true,
    walletBalance: 0,
    country: "",
    fixedCountry: "",
    countryCode: "",
    countryFlag: "",
    currency: "",
    rankPoints: 0,
    rank: "",
    accountStatus: "",
    roles: Roles.admin,
    avatar: "",
    ipAddress: "",
    loginProvider: "",
    verifiedEmail: false,
    userVerification: "",
    paymentVerification: "",
    resetToken: "",
    banStatus: BanStatus.normal,
    notes: [],
    twoFactorAuth: false,
    twoFactorSecret: "",
    emailToken: "",
    passwordCheck: false,
    createdAt: "",
    message: "",
    lastLogin: "",
    language: "",
    suggestedCurrency: "",
    suggestedLanguage: "",
    disabledPaymentMethods: [],
  },
  login: false
}
